var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCellphoneGradientIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 980.00352 980.76105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Gradiente_sem_nome_42);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_42",
    x1: 10.18187,
    y1: 132.2021,
    x2: 847.70645,
    y2: 969.72668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ff6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12835,
    stopColor: "#00fa70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30789,
    stopColor: "#00ec83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51758,
    stopColor: "#00d5a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75011,
    stopColor: "#00b5ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008cff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.63845,9.85037c-90.45,38.56-157.06,93.72-176.69,145.61-4.44,11.69-5.14,18.23-4.91,46.28.23,60.77,14.96,128.08,44.64,203.34,40.43,102.36,100.03,194.68,186.28,288.64,153.79,167.34,360.4,277.66,537.79,286.54,33.19,1.87,48.61-1.17,74.56-14.72,43.24-22.44,96.53-93.72,128.55-171.79,9.35-22.44,10.05-27.11,5.14-36.46-3.98-7.72-219.7-161.04-233.02-165.71-9.58-3.04-20.33-2.1-30.62,3.04-3.51,1.87-22.67,23.37-42.77,47.68-40.9,49.78-46.51,54.22-69.18,54.46-12.39,0-15.89-1.17-44.64-17.06-129.49-70.82-185.81-127.15-256.62995-256.63-15.89-28.98-17.06-32.26-17.06-44.88.23-22.44,5.38-28.98,54.46-69.18,23.84-19.4,45.11-38.8,47.68-42.77,4.91-8.65,5.61-27.11,1.4-35.53-1.64-3.04-37.86-54.92-80.4-114.99-49.78-70.82-79.47-110.78-83.67-112.89C212.95846-2.06963,207.57845-1.13963,181.63845,9.85037Z",
    transform: "translate(0 -0.00001)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellphoneGradientIc);
export default __webpack_public_path__ + "static/media/cellphone-gradient-ic.941e47e8ab97e0d42652009eb1f86737.svg";
export { ForwardRef as ReactComponent };